export default function VisionValues() {
  const values = [
    {
      icon: 'ri-hand-heart-line',
      title: 'お客様第一',
      subtitle: 'Customer First',
      description: 'お客様の課題に真摯に向き合い、建物という大切な資産を守るために最適なソリューションを提供します。一時的な解決ではなく、長期的な視点でお客様の利益を最優先に考えます。',
      color: 'blue',
      bgColor: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-team-line',
      title: 'チームワーク',
      subtitle: 'Teamwork',
      description: 'グループ一丸となって、それぞれの専門性を活かしながら高品質なサービスを提供します。個々の力を結集し、お客様により大きな価値をお届けします。',
      color: 'green',
      bgColor: 'from-green-500 to-green-600'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'イノベーション',
      subtitle: 'Innovation',
      description: '常に新しい技術と手法を取り入れ、従来の枠を超えた創造的なソリューションを提供します。建物の可能性を最大限に引き出すイノベーションを追求します。',
      color: 'orange',
      bgColor: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-handshake-line',
      title: 'パートナーシップ',
      subtitle: 'Partnership',
      description: 'パートナーとの信頼関係を大切にし、透明性の高いコミュニケーションを通じて、共に成長していける関係を築きます。長期的な視点で互いの成功を支え合います。',
      color: 'purple',
      bgColor: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: '品質へのこだわり',
      subtitle: 'Quality Excellence',
      description: '妥協のない品質管理と継続的な改善により、お客様の期待を上回る結果を提供します。すべての工程において最高水準の品質を維持します。',
      color: 'red',
      bgColor: 'from-red-500 to-red-600'
    },
    {
      icon: 'ri-leaf-line',
      title: '持続可能性',
      subtitle: 'Sustainability',
      description: '環境に配慮した施工とメンテナンスを通じて、持続可能な社会の実現に貢献します。未来の世代に美しい環境を残すことも私たちの責任です。',
      color: 'emerald',
      bgColor: 'from-emerald-500 to-emerald-600'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold mb-4">
            OUR VALUES
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            私たちの価値観
          </h2>
          <div className="w-16 h-1 bg-blue-600 rounded-full mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            「Reason To Believe」を実現するために、私たちが大切にしている6つの価値観をご紹介します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2"
            >
              <div className={`h-2 bg-gradient-to-r ${value.bgColor}`}></div>
              
              <div className="p-8">
                <div className={`w-16 h-16 bg-${value.color}-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${value.icon} text-${value.color}-600 text-2xl`}></i>
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {value.title}
                </h3>
                
                <h4 className={`text-sm font-semibold text-${value.color}-600 mb-4 tracking-wide uppercase`}>
                  {value.subtitle}
                </h4>
                
                <p className="text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>

              <div className={`h-1 bg-gradient-to-r ${value.bgColor} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left`}></div>
            </div>
          ))}
        </div>

        {/* Values in Action */}
        <div className="mt-20 bg-white rounded-3xl shadow-xl p-12">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">価値観の実践</h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              これらの価値観は、私たちの日々の業務や意思決定の基盤となっています
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/bf7f77ccc413ba08879defa32a3890c0.jpg"
                alt="価値観の実践"
                className="w-full rounded-2xl shadow-lg object-cover object-top"
              />
            </div>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="bg-blue-100 p-3 rounded-xl flex-shrink-0">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-checkbox-circle-line text-blue-600 text-xl"></i>
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">定期的な研修とスキルアップ</h4>
                  <p className="text-gray-600 text-sm">最新の技術と知識を習得し、お客様により良いサービスを提供するための継続的な学習</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-green-100 p-3 rounded-xl flex-shrink-0">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-user-smile-line text-green-600 text-xl"></i>
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">お客様との密なコミュニケーション</h4>
                  <p className="text-gray-600 text-sm">プロジェクトの各段階でお客様と情報を共有し、透明性の高いサービス提供</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-purple-100 p-3 rounded-xl flex-shrink-0">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-award-line text-purple-600 text-xl"></i>
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">品質管理とアフターサービス</h4>
                  <p className="text-gray-600 text-sm">施工完了後も継続的なサポートを提供し、長期的な満足度の向上を実現</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
